import { Toasts } from '@fourthwall/components';
import { useActivateThemeMutation } from '../../../../hooks/useActivateThemeMutation';
import { useCurrentShopContext } from '../../../../hooks/useCurrentShopContext';
import { useActiveThemeContext } from '../../../../providers/ActiveThemeProvider';
import { useShopContext } from '../../../../providers/ShopProvider';
export const useThemeStatusButton = () => {
    const { currentShop } = useCurrentShopContext();
    const { refetch } = useShopContext();
    const { activateThemeMutation } = useActivateThemeMutation();
    const { activeTheme, setActiveTheme } = useActiveThemeContext();
    const handleActivateSelectedTheme = (callback) => {
        activateThemeMutation.mutate([{ shop_id: currentShop.id, theme_id: activeTheme.id }, { theme: { role: 'main' } }], {
            onSuccess: () => {
                Toasts.notify('Theme has been activated', { type: 'info' });
                setActiveTheme({ id: activeTheme.id, name: 'Main' });
                refetch();
                callback?.();
            },
        });
    };
    return { handleActivateSelectedTheme };
};
